import { render, staticRenderFns } from "./WBtnClose.vue?vue&type=template&id=26b7eb8c&scoped=true&"
import script from "./WBtnClose.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnClose.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7eb8c",
  null
  
)

export default component.exports